export async function checkSelectionQuote(body: Record<string, unknown>, signal: AbortSignal, request: typeof fetch = fetch): Promise<'available' | 'unavailable' | 'temporary'> {
  // Use the same supplier-method expansion and quote-correspondence checks as
  // the main price request. A stale hidden method must not reject a valid choice.
  const response = await request('/api/printcom/calculate-price', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ pricingMode: 'api', expandPrintingMethods: true, batch: [body] }), signal: AbortSignal.any([signal, AbortSignal.timeout(30_000)]) });
  const payload = await response.json();
  const result = Array.isArray(payload?.results) ? payload.results[0] : payload;
  if (!result) return 'temporary';
  if (response.ok && result.success === true && !result.fallback && Number(result.calculation?.total ?? result.pricing?.total ?? result.total) > 0) return 'available';
  if (['SUPPLIER_CONFIGURATION_UNAVAILABLE', 'CONFIGURATION_IMPOSSIBLE', 'INVALID_PRINTCOM_CONFIGURATION'].includes(result.code)) return 'unavailable';
  // Print.com's batch-endpoint gaf bij visitekaartjes in PaperWise een 500,
  // terwijl de losse prijsvraag netjes "no supplier prices found" meldde. Een
  // mislukte batch zegt dus niets; vraag dezelfde samenstelling één keer los.
  if (result.code === 'BATCH_FAILURE') {
    const single = await request('/api/printcom/calculate-price', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...body, pricingMode: 'api' }), signal: AbortSignal.any([signal, AbortSignal.timeout(30_000)]) });
    const singleResult = await single.json().catch(() => null);
    if (singleResult && ['SUPPLIER_CONFIGURATION_UNAVAILABLE', 'CONFIGURATION_IMPOSSIBLE', 'INVALID_PRINTCOM_CONFIGURATION'].includes(singleResult.code)) return 'unavailable';
  }
  return 'temporary';
}

export function optionSelectionKey(configuration: Record<string, unknown>, optionId: string, value: unknown, country: string) {
  return JSON.stringify([country, optionId, String(value), Object.entries(configuration).filter(([key]) => key !== optionId).sort(([a],[b]) => a.localeCompare(b))]);
}

/**
 * Probe voor de waarde-beschikbaarheid (zie value-availability.ts): dezelfde
 * samenstelling met alleen de gekozen optie terug op de vorige waarde. Weigert
 * Print.com de nieuwe keuze met "no supplier prices", dan prijst de server deze
 * vorige samenstelling één keer; lukt dat, dan is de gekozen waarde de oorzaak.
 * De server vertrouwt dit niet blind en controleert dat er precies één optie
 * verschilt.
 */
export function buildSelectionProbe(optionId: string, value: unknown, effectiveConfiguration: Record<string, unknown>, previousValue: unknown) {
  if (previousValue === undefined || previousValue === null || previousValue === '' || String(previousValue) === String(value)) return undefined;
  return { optionId, value: String(value), previousOptions: { ...effectiveConfiguration, [optionId]: previousValue } };
}
